import {
  AttendanceMutationsUpdateAttendanceEmployeesSettingArgs,
  UpdateAttendanceSettingDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateTimeTrackingSetting = () => {
  const [updateTimeTrackingSetting, { loading }] = useMutation(UpdateAttendanceSettingDocument, {
    extractorFn: (data) => data.attendanceMutations.updateAttendanceEmployeesSetting,
  })

  const updateSetting = (variables: AttendanceMutationsUpdateAttendanceEmployeesSettingArgs) => {
    return updateTimeTrackingSetting({
      variables,
    })
  }

  return {
    loading,
    updateSetting,
  }
}
